import { cleanPartnerBasedPlatformNames } from '../utils/partner-based-string-cleaning';
import { WORKSPACE_SPECIFIC_LOCALIZED_STRINGS } from './workspace-specific-localized-strings';
var PLACEHOLDER = '[]';
export var LOCALIZED_STRINGS = {
    USES_PINWHEEL: {
        es: "".concat(PLACEHOLDER, " usa Pinwheel para conectar tu ").concat(PLACEHOLDER),
        en: "".concat(PLACEHOLDER, " uses Pinwheel to connect to your ").concat(PLACEHOLDER),
    },
    PAYROLL: {
        es: 'cuenta de nómina',
        en: 'payroll account',
    },
    TIME_AND_ATTENDANCE: {
        es: 'cuenta de tiempo y asistencia',
        en: 'time and attendance account',
    },
    TAX: {
        es: 'cuenta de impuestos',
        en: 'tax account',
    },
    ENCRYPTED_AND_SECURE: {
        es: 'Encriptado y Seguro',
        en: 'Encrypted & Secure',
    },
    ENCRYPTED_AND_PRIVATE: {
        es: 'Encriptado y Privado',
        en: 'Encrypted & Private',
    },
    YOUR_INFORMATION: {
        es: 'Tu información está encriptada de extremo a extremo.',
        en: 'Your information is encrypted end-to-end.',
    },
    ENCRYPTED_AND_PRIVATE_DETAIL: {
        es: "Tu informaci\u00F3n est\u00E1 encriptada y ".concat(PLACEHOLDER, " nunca podr\u00E1 acceder a tus credenciales."),
        en: "Your information is encrypted and ".concat(PLACEHOLDER, " will never be able to access your credentials."),
    },
    ALWAYS_PRIVATE: {
        es: 'Siempre Privado',
        en: 'Always Private',
    },
    WILL_NEVER: {
        es: "".concat(PLACEHOLDER, " nunca podr\u00E1 acceder a tus credenciales."),
        en: "".concat(PLACEHOLDER, " will never be able to access your credentials."),
    },
    CONVENIENT_AND_FAST: {
        es: 'Conveniente y Rápido',
        en: 'Convenient & Fast',
    },
    ABOUT_PINWHEEL: {
        es: 'Acerca de Pinwheel',
        en: 'About Pinwheel',
    },
    HOW_WE_PROTECT: {
        es: 'Cómo protegemos tus datos',
        en: 'How we protect your data',
    },
    CONTINUE: {
        es: 'Continuar',
        en: 'Continue',
    },
    CONTINUE_ANYWAY: {
        es: 'Continuar de todos modos',
        en: 'Continue anyway',
    },
    PINWHEEL_LETS_YOU: {
        es: "Pinwheel te permite conectar tu ".concat(PLACEHOLDER, " a aplicaciones y servicios para que puedas aprovechar al m\u00E1ximo tus finanzas."),
        en: "Pinwheel lets you connect your ".concat(PLACEHOLDER, " to apps and services so you can make the most of your finances."),
    },
    ACCOUNT_TO_AN_APP: {
        es: "Cuando usas Pinwheel para conectar una ".concat(PLACEHOLDER, " a una aplicaci\u00F3n, mantenemos tus datos seguros y privados con protocolos de cifrado a nivel bancario como el est\u00E1ndar de cifrado avanzado (AES 256) y la seguridad de la capa de transporte (TLS)."),
        en: "When you use Pinwheel to connect a ".concat(PLACEHOLDER, " to an app, we help keep your data safe and private with bank-level encryption protocols like the Advanced Encryption Standard (AES 256) and Transport Layer Security (TLS)."),
    },
    SANDBOX_MODE: {
        es: 'Actualmente estás en modo Sandbox. Las credenciales son',
        en: 'You are currently in Sandbox mode. Credentials are',
    },
    POPULAR_PAYROLL: {
        es: 'Proveedores de nómina populares',
        en: 'Popular payroll providers',
    },
    POPULAR_EMPLOYERS: {
        es: 'Empleadores populares',
        en: 'Popular employers',
    },
    SEE_ALL: {
        es: 'Ver todo',
        en: 'See all',
    },
    SEARCH_LIST: {
        es: 'Buscar en la lista de todas las empresas',
        en: 'Search list of all companies',
    },
    WHO_PAYS_YOU: {
        es: '¿Quién te paga?',
        en: 'Who pays you?',
    },
    WHO_IS_YOUR_PAYROLL_PROVIDER: {
        es: '¿Quién es su proveedor de nómina?',
        en: 'Who is your payroll provider?',
    },
    WHO_IS_YOUR_TAX_PROVIDER: {
        es: '¿Qué servicio de impuestos utilizó el año pasado?',
        en: 'What tax service did you use last year?',
    },
    SELECT_YOUR_PAYROLL_PLATFORM: {
        es: 'Elige tu sistema de nómina',
        en: 'Select your payroll platform',
    },
    SEARCH: {
        es: 'Buscar',
        en: 'Search',
    },
    SEARCH_ALL: {
        en: 'Search all',
        es: 'Buscar todo',
    },
    SEARCH_ALL_EMPLOYERS_PROVIDERS: {
        en: 'Search all employers and providers',
        es: 'Buscar todos los empleadores y proveedores',
    },
    SEARCH_FOR_PAYROLL: {
        es: 'Buscar proveedor de nómina',
        en: 'Search for payroll provider',
    },
    SEARCH_ALL_PROVIDERS: {
        en: 'Search across all employers and payroll providers',
        es: 'Busque en todos los empleadores y proveedores de nómina',
    },
    SEARCH_BY_NAME: {
        es: 'Buscar por nombre',
        en: 'Search by name',
    },
    SEARCH_PAYROLL_PROVIDERS: {
        es: 'Buscar proveedores de nómina',
        en: 'Search payroll providers',
    },
    NO_RESULTS: {
        es: "No hay resultados para \"".concat(PLACEHOLDER, "\""),
        en: "No results for \"".concat(PLACEHOLDER, "\""),
    },
    TRY_PAYROLL: {
        es: 'Intenta buscar por proveedor de nómina',
        en: 'Try searching by payroll provider',
    },
    TRY_SEARCHING: {
        es: 'Intenta buscar',
        en: 'Try searching',
    },
    NO_RESULTS_FOR: {
        es: "No se encontraron resultados para \"".concat(PLACEHOLDER, "\". Recomendamos buscar por proveedor de n\u00F3mina."),
        en: "No results for \"".concat(PLACEHOLDER, "\" were found. We recommend using the payroll provider search instead."),
    },
    NO_RESULTS_FOR_TRY_AGAIN: {
        es: "No se encontraron resultados para \"".concat(PLACEHOLDER, "\". Revisa tu ortograf\u00EDa e intenta buscar de nuevo."),
        en: "No results for \"".concat(PLACEHOLDER, "\" were found. Check your spelling and try again."),
    },
    EMPLOYER_NOT_LISTED: {
        es: '¿Empleador no listado? Ningún\u00a0problema.',
        en: 'Employer not listed? No\u00a0problem.',
    },
    NO_RESULTS_DESCRIPTION: {
        es: 'Los empleadores utilizan proveedores de servicios de nómina para pagar a sus empleados. Para continuar, busca\u00a0el\u00a0tuyo...',
        en: 'Employers use payroll service providers to pay their employees. To continue, search\u00a0for\u00a0yours...',
    },
    CANT_FIND_EMPLOYER: {
        es: '¿No encuentras a tu empleador? Busca por proveedores de nómina',
        en: "Can't find your employer? Search payroll providers instead",
    },
    CANT_FIND_EMPLOYER_WORKDAY: {
        es: '¿No encuentras a tu empleador?',
        en: "Can't find your employer?",
    },
    CANT_FIND_IT: {
        es: '¿No puedes encontrarlo?',
        en: "Can't find it?",
    },
    SEARCH_PROVIDERS_INSTEAD: {
        es: 'Busca por proveedores de nómina',
        en: 'Search by payroll providers instead',
    },
    DONT_SEE_IT_SEARCH_MORE: {
        es: '¿No ves tu plataforma de nómina? Busca más.',
        en: "Don't see your payroll platform? Search for more.",
    },
    DONT_SEE_EMPLOYER: {
        es: '¿No ves tu empleador?',
        en: "Don't see your employer?",
    },
    BEGIN_TYPING_TO_SEARCH_PLATFORM: {
        es: 'Comience a escribir para buscar su proveedor de nómina.',
        en: 'Begin typing to search for your payroll provider.',
    },
    NO_RESULTS_FOUND: {
        es: 'No se han encontrado resultados',
        en: 'No results found',
    },
    WHERE_DO_YOU_LOG: {
        es: '¿Dónde registras tus horas de trabajo?',
        en: 'Where do you log your work hours?',
    },
    YES: {
        es: 'Sí',
        en: 'Yes',
    },
    NO: {
        es: 'No',
        en: 'No',
    },
    SEARCH_FOR_YOUR_EMPLOYER: {
        es: 'Busca tu empleador o proveedor de nómina para actualizar tu configuración de depósito directo.',
        en: 'Search for your employer or payroll provider instead to update your direct deposit settings.',
    },
    SELECT_WORKDAY_EMPLOYER: {
        es: 'Seleccione su empleador de Workday',
        en: 'Select your Workday employer',
    },
    GO_BACK_TO_SEARCH: {
        es: 'Volver a buscar',
        en: 'Go back to search',
    },
    ARE_YOU_A: {
        es: "\u00BFEres empleado de ".concat(PLACEHOLDER, "?"),
        en: "Are you a ".concat(PLACEHOLDER, " employee?"),
    },
    LOGIN_USING_ACCOUNT: {
        es: "Inicia sesi\u00F3n usando tu cuenta de ".concat(PLACEHOLDER),
        en: "Log in using your ".concat(PLACEHOLDER, " account"),
    },
    TROUBLE_LOGGING_IN: {
        es: '¿Problemas para iniciar sesión?',
        en: 'Trouble logging in?',
    },
    FORGOT_USER_ID: {
        es: '¿Olvidaste tu ID de usuario o la contraseña?',
        en: 'Forgot User ID or Password?',
    },
    NOT_YOUR_PAYROLL: {
        es: '¿No es tu sistema de nómina?',
        en: 'Not your payroll system?',
    },
    TROUBLE_GETTING_CONNECTED: {
        es: 'Estamos teniendo problemas para conectarte.',
        en: "Looks like we're having trouble getting you connected.",
    },
    PLEASE_TRY_AGAIN: {
        es: 'Por favor, inténtelo de nuevo más tarde.',
        en: 'Please try again later.',
    },
    WORKING_ON_REQUEST: {
        es: 'Estamos trabajando en tu solicitud.',
        en: 'We are working on your request',
    },
    WILL_LET_YOU_KNOW: {
        es: "".concat(PLACEHOLDER, " le permitir\u00E1 saber cu\u00E1ndo se ha completado."),
        en: "".concat(PLACEHOLDER, " will let you know when it has been completed."),
    },
    RETRY: {
        es: 'Reintentar',
        en: 'Retry',
    },
    CLOSE: {
        es: 'Cerrar',
        en: 'Close',
    },
    GET_INSTANT_PAYCHECK: {
        es: 'obtener cheque de pago instantáneo',
        en: 'get Instant Paycheck',
    },
    UPDATE_YOUR_DIRECT: {
        es: 'actualizar tu configuración de depósito directo',
        en: 'update your direct deposit settings',
    },
    CONNECT_YOUR: {
        es: "conectar tu ".concat(PLACEHOLDER),
        en: "connect your ".concat(PLACEHOLDER),
    },
    WELCOME_BACK: {
        es: '¡Bienvenido de nuevo!',
        en: 'Welcome back!',
    },
    LOGIN_TO_EMPLOYER: {
        es: "Inicia sesi\u00F3n en ".concat(PLACEHOLDER, " usando tu ").concat(PLACEHOLDER, " ").concat(PLACEHOLDER),
        en: "Log in to ".concat(PLACEHOLDER, " using your ").concat(PLACEHOLDER, " ").concat(PLACEHOLDER),
    },
    LOGIN_TO_ACTION: {
        es: "Inicia sesi\u00F3n con tus credenciales de ".concat(PLACEHOLDER, " para ").concat(PLACEHOLDER, "."),
        en: "Log in using your ".concat(PLACEHOLDER, " credentials to ").concat(PLACEHOLDER, "."),
    },
    LOGIN_USING_CREDENTIALS: {
        es: "Inicia sesi\u00F3n con tus credenciales para ".concat(PLACEHOLDER, "."),
        en: "Log in using your credentials to ".concat(PLACEHOLDER, "."),
    },
    NAME_BIRTH_DATE_SSN: {
        es: "Nombre, fecha de nacimiento y SSN",
        en: "Name, birthdate, and SSN",
    },
    USERNAME_AND_PASSWORD: {
        es: "Nombre de usuario y contrase\u00F1a",
        en: "Username and password",
    },
    ROUTING_AND_ACCOUNT: {
        es: "Edite su configuraci\u00F3n de dep\u00F3sito directo para incluir sus n\u00FAmeros de ruta y de cuenta de ".concat(PLACEHOLDER),
        en: "Edit your direct deposit settings to include your ".concat(PLACEHOLDER, " routing and account numbers"),
    },
    COPIED: {
        es: 'Copiado',
        en: 'Copied',
    },
    COPY: {
        es: 'Copiar',
        en: 'Copy',
    },
    ACCOUNT: {
        es: 'Número de cuenta',
        en: 'Account number',
    },
    ROUTING: {
        es: 'Número de ruta',
        en: 'Routing number',
    },
    UPDATE_DD: {
        es: 'Actualiza tus preferencias de depósito directo',
        en: 'Update your direct deposit preferences',
    },
    FOLLOW_INSTRUCTIONS: {
        es: 'Sigue las instrucciones a continuación para actualizar/cambiar tus preferencias de depósito directo',
        en: 'Follow the instructions below to update/change your direct deposit preferences',
    },
    SOMETHING_UNEXPECTED_HAPPENED: {
        es: '¡Oh, no! ha ocurrido algo inesperado.',
        en: 'Something unexpected happened.',
    },
    TRYING_TO_FIX: {
        es: 'Estamos tratando de arreglar esto lo más rápido posible, así que por favor intenta nuevamente más tarde.',
        en: 'We are trying to fix this as quickly as possible, so please try again later.',
    },
    TERMS_1: {
        es: 'Al seleccionar “Continuar”, reconoce que ha revisado y acepta los',
        en: "By selecting “Continue” you acknowledge you have reviewed and agree to Pinwheel's",
    },
    TERMS_1_GET_STARTED: {
        es: 'Al seleccionar “Empezar”, reconoce que ha revisado y acepta los',
        en: "By selecting “Get started” you acknowledge you have reviewed and agree to Pinwheel's",
    },
    TERMS_1_PROCEEDING: {
        es: 'Al continuar, reconoces que has revisado y aceptas los',
        en: "By proceeding, you acknowledge you have reviewed and agree to Pinwheel's",
    },
    TERMS_2: {
        es: 'Términos de Servicio',
        en: 'Terms of Service',
    },
    TERMS_3: {
        es: 'y la',
        en: '&',
    },
    TERMS_4: {
        es: 'Política de Privacidad',
        en: 'Privacy Policy',
    },
    TERMS_5: {
        es: ' de Pinwheel',
        en: '',
    },
    DONE: {
        es: 'Listo',
        en: 'Done',
    },
    HOW_MUCH: {
        es: '¿Cuánto te gustaría depositar?',
        en: 'How much would you like to deposit?',
    },
    HOW_MUCH_TO_ORG: {
        es: "\u00BFCu\u00E1nto te gustar\u00EDa que sea depositado a ".concat(PLACEHOLDER, " en el futuro?"),
        en: "How much do you want to be directly deposited to ".concat(PLACEHOLDER, " in the future?"),
    },
    DIRECT_DEPOSIT_SETTINGS: {
        es: 'Configuración de depósito\u00a0directo',
        en: 'Direct deposit settings',
    },
    PAYOUT_SETTINGS: {
        es: 'Configuración de depósito\u00a0directo',
        en: 'Payout settings',
    },
    YOU_CAN_CHANGE: {
        es: 'Esto puede ser modificado dentro de tu configuración de nómina en cualquier momento.',
        en: 'You can change this within your payroll settings at any time.',
    },
    SPECIFIC_AMOUNT: {
        es: 'Monto específico',
        en: 'Specific amount',
    },
    AMOUNT: {
        es: 'Monto',
        en: 'Amount',
    },
    FREQUENCY: {
        es: 'Frecuencia',
        en: 'Frequency',
    },
    EMPLOYER: {
        es: 'Empleador',
        en: 'Employer',
    },
    PERCENTAGE: {
        es: 'Porcentaje',
        en: 'Percentage',
    },
    DEPOSIT_TO: {
        es: 'Depositar a',
        en: 'Deposit to',
    },
    REMAINDER: {
        es: 'Restante',
        en: 'Remainder',
    },
    REMAINDER_FOR_LEGACY_SWITCH: {
        es: 'Restante (tu cheque de pago, menos tus depósitos existentes',
        en: 'Remainder (your paycheck, minus existing deposits)',
    },
    REMAINDER_DISCLAIMER: {
        en: 'Use this option to switch the “Remainder” of your paycheck while leaving existing fixed or percentage direct deposit allocations unaffected.',
        es: 'Utilice esta opción para cambiar el "Restante" de su cheque de pago sin afectar las asignaciones de depósito directo fijo o porcentual existente.',
    },
    FULL_PAYCHECK: {
        es: 'Pago completo',
        en: 'Full paycheck',
    },
    PARTIAL_PAYCHECK: {
        es: 'Pago parcial',
        en: 'Partial paycheck',
    },
    EVERY_PAYCHECK: {
        en: 'Every paycheck',
        es: 'Cada cheque de pago',
    },
    CONFIRM: {
        es: 'Confirmar',
        en: 'Confirm',
    },
    REVIEW_DEPOSIT: {
        es: 'Revisar la actualización del depósito',
        en: 'Review deposit update',
    },
    CONFIRM_DEPOSIT_SETTINGS: {
        es: 'Confirmar la configuración del depósito\u00a0directo',
        en: 'Confirm direct deposit\u00a0settings',
    },
    YOUR_PAYCHECK_WILL: {
        es: "Tu cheque de pago se depositar\u00E1 en ".concat(PLACEHOLDER, "."),
        en: "Your paycheck will be deposited into ".concat(PLACEHOLDER, "."),
    },
    YOUR_PAYCHECK_WILL_BE_DEPOSITED: {
        es: "Tu cheque de pago se depositar\u00E1 en\u00A0".concat(PLACEHOLDER, "."),
        en: "Your paycheck will be deposited into\u00A0".concat(PLACEHOLDER, "."),
    },
    YOUR_PAYCHECK_WILL_BE_DEPOSITED_AND_ALLOCATIONS_REMOVED: {
        es: "Tu cheque de pago se depositar\u00E1 a ".concat(PLACEHOLDER, " y cualquier asignaci\u00F3n existente ser\u00E1 removida."),
        en: "Your paycheck will be deposited to ".concat(PLACEHOLDER, " and any existing allocations will be removed."),
    },
    WHEN_YOUR_LOAN: {
        es: 'Cuando pagues tu préstamo por completo, inicia sesión en tu cuenta de nómina para detener tu pago a Kashable.',
        en: 'When your loan is paid in full, log in to your payroll account to stop your payment to Kashable.',
    },
    AMOUNT_PER_PAYCHECK: {
        es: 'Cantidad por cheque de pago',
        en: 'Amount per paycheck',
    },
    YOUR_PAYCHECK: {
        es: 'tu cheque de pago',
        en: 'your paycheck',
    },
    THE_SPECIFIED_AMOUNT: {
        es: 'la cantidad especificada',
        en: 'the specified amount',
    },
    BY_CLICKING_CONFIRM: {
        es: "Al confirmar, se enviar\u00E1 el monto especificado en d\u00F3lares a ".concat(PLACEHOLDER, " por cada cheque de pago"),
        en: "By clicking confirm, the specified dollar amount will be sent to ".concat(PLACEHOLDER, " per paycheck"),
    },
    YOUR_DIRECT_DEPOSIT: {
        es: '¡Tu configuración de depósito directo se ha actualizado!',
        en: 'Your direct deposit settings have been updated!',
    },
    YOUR_DIRECT_DEPOSIT_DISCOVER: {
        es: 'Has conectado exitosamente tu proveedor de nómina. Importaremos automáticamente tus documentos de nómina.',
        en: 'You have successfully connected your payroll provider. We will automatically import your payroll documents.',
    },
    SUCCESS_SUBTITLE: {
        en: '',
        es: '',
    },
    YOUR_CHANGES_SHOULD: {
        es: 'Sus cambios deberían ser efectivos en 1-2 ciclos\u00A0de\u00A0nómina.',
        en: 'Your changes should be effective in 1-2 payroll\u00A0cycles.',
    },
    YOUR_ACCOUNT_RECONNECTED: {
        es: "Tu cuenta ha sido reconectada con ".concat(PLACEHOLDER),
        en: "Your account has been reconnected with ".concat(PLACEHOLDER),
    },
    YOUR_ACCOUNT_CONNECTED: {
        es: "Tu cuenta ha sido conectada con ".concat(PLACEHOLDER),
        en: "Your account has been connected with ".concat(PLACEHOLDER),
    },
    YOUR_ORGANIZATION_CONNECTED: {
        es: "Felicitaciones! Tu orgnizaci\u00F3n ha sido conectada",
        en: "Congrats! Your organization is now connected",
    },
    COMMUNICATING_WITH: {
        es: "Comunic\u00E1ndonos con tu ".concat(PLACEHOLDER),
        en: "Communicating with your ".concat(PLACEHOLDER),
    },
    CONNECTING_TO: {
        es: "Connectando a tu ".concat(PLACEHOLDER),
        en: "Connecting to your ".concat(PLACEHOLDER),
    },
    RECONNECTING_TO: {
        es: "Reconectando a tu ".concat(PLACEHOLDER),
        en: "Reconnecting to your ".concat(PLACEHOLDER),
    },
    STOP_NOW: {
        es: '¿Estás seguro de que quieres salir?',
        en: 'Are you sure you want to exit?',
    },
    DONT_GIVE_UP: {
        es: 'No te rindas',
        en: "Don't give up",
    },
    YOUR_PROGRESS_LOST: {
        es: 'Tu progreso se perderá.',
        en: 'Your progress will be lost.',
    },
    YOURE_ALMOST_THERE: {
        es: '¡Ya casi estás ahí! ¿Quieres intentar buscar tu cuenta usando alguna información personal?',
        en: "You're almost there! Do you want to try looking up your account using some personal information?",
    },
    LOOK_UP_MY_ACCOUNT: {
        es: 'Buscar mi cuenta',
        en: 'Look up my account',
    },
    RETURN_TO_BANKAPP: {
        es: "Volver a ".concat(PLACEHOLDER),
        en: "Return to ".concat(PLACEHOLDER),
    },
    EXIT: {
        es: 'Salir',
        en: 'Exit',
    },
    GO_BACK: {
        es: 'Regresar',
        en: 'Go Back',
    },
    ERROR_PERCENTAGE_BETWEEN_LIMITS: {
        es: "Favor de ingresar un valor entre ".concat(PLACEHOLDER, "% y ").concat(PLACEHOLDER, "%"),
        en: "Please enter a value between ".concat(PLACEHOLDER, "% and ").concat(PLACEHOLDER, "%"),
    },
    ERROR_VALUE_BETWEEN_LIMITS: {
        es: "Favor de ingresar un valor entre ".concat(PLACEHOLDER, " y ").concat(PLACEHOLDER),
        en: "Please enter a value between ".concat(PLACEHOLDER, " and ").concat(PLACEHOLDER),
    },
    ERROR_VALUE_SMALLER_THAN_LIMIT: {
        es: "Favor de ingresar un valor menor a ".concat(PLACEHOLDER),
        en: "Please enter an amount less than ".concat(PLACEHOLDER),
    },
    ERROR_VALUE_LARGER_THAN_LIMIT: {
        es: "Favor de ingresar un valor mayor a ".concat(PLACEHOLDER),
        en: "Please enter an amount greater than ".concat(PLACEHOLDER),
    },
    REMOVE_EXISTING_ALLOCATIONS_TO_ORGNAME: {
        es: "Removeremos su asignaci\u00F3n de dep\u00F3sito directo existente a ".concat(PLACEHOLDER),
        en: "We will remove your existing direct deposit allocation to ".concat(PLACEHOLDER),
    },
    VIEW_CURRENT_DD_SETTINGS: {
        es: 'Ver configuración de depósito directo',
        en: 'View current direct deposit settings',
    },
    LOADING_ALLOCATIONS_TITLE: {
        es: 'Obteniendo la configuración actual de depósito directo de su\u00a0cuenta...',
        en: 'Getting current direct deposit settings from your\u00a0account...',
    },
    LOADING_ALLOCATIONS_ROTATING_TEXT_1: {
        es: 'Esto suele tardar unos 10\u00a0segundos',
        en: 'This usually takes about 10\u00a0seconds',
    },
    LOADING_ALLOCATIONS_ROTATING_TEXT_2: {
        es: 'Algunos proveedores de nómina tardan más, lo\u00a0sentimos',
        en: 'Some payroll providers take longer,\u00a0sorry',
    },
    LOADING_ALLOCATIONS_ROTATING_TEXT_3: {
        es: 'Gracias por su\u00a0paciencia',
        en: 'Thanks for your\u00a0patience',
    },
    LOADING_ALLOCATIONS_ROTATING_TEXT_4: {
        es: 'Todavía estamos trabajando en contactar a su proveedor de\u00a0nómina',
        en: 'Still working on contacting your payroll\u00a0provider',
    },
    LOADING_ALLOCATIONS_ROTATING_TEXT_5: {
        es: 'Esto está tardando más de lo que\u00a0debería',
        en: 'This is taking longer than it\u00a0should',
    },
    LOADING_ALLOCATIONS_ROTATING_TEXT_6: {
        es: 'Algo debe estar\u00a0mal',
        en: 'Something must be\u00a0wrong',
    },
    ALLOCATION_VIEWING_TITLE: {
        es: 'Asignaciones actuales',
        en: 'Current allocations',
    },
    ALLOCATION_VIEWING_ERROR_SUBMIT_TEXT: {
        es: 'Regresar',
        en: 'Back',
    },
    ALLOCATION_VIEWING_ERROR_MESSAGE: {
        es: 'Lo sentimos, no pudimos obtener su configuración actual de depósito\u00a0directo',
        en: 'Sorry, we were unable to get your current direct deposit\u00a0settings',
    },
    ACCOUNT_SELECTION_TITLE: {
        en: 'Direct deposit settings',
        es: 'Configuración de depósito\u00a0directo',
    },
    ACCOUNT_SELECTION_SUBTITLE: {
        en: 'To which account should the deposit go?',
        es: '¿A qué cuenta debe ir el depósito?',
    },
    ACCOUNT_SELECTION_SUBMIT: {
        en: 'Confirm',
        es: 'Confirmar',
    },
    EXIT_SURVEY_SUBMIT: {
        en: 'Submit',
        es: 'Enviar',
    },
    EXIT_SURVEY_NEXT: {
        en: 'Next',
        es: 'Siguiente',
    },
    EXIT_SURVEY_SKIP: {
        en: 'Skip',
        es: 'Omitir',
    },
    SWITCH_CONFIRMATION_TITLE: {
        en: "Review & Confirm",
        es: "Revise y Confirme",
    },
    SWITCH_CONFIRMATION_TITLE_WITH_EMPLOYER: {
        en: "Deposit your paychecks from ".concat(PLACEHOLDER, " to\u00A0").concat(PLACEHOLDER),
        es: "Deposita tus cheques de pago de ".concat(PLACEHOLDER, " a\u00A0").concat(PLACEHOLDER),
    },
    SWITCH_CONFIRMATION_TITLE_WITHOUT_EMPLOYER: {
        en: "Deposit your paychecks to\u00A0".concat(PLACEHOLDER),
        es: "Deposita tus cheques de pago a\u00A0".concat(PLACEHOLDER),
    },
    SWITCH_CONFIRMATION_SUBTITLE: {
        en: 'Please review and confirm these details',
        es: 'Por favor revise y confirme estos detalles',
    },
    INTERVIEW_RECRUITMENT_BEFORE_YOU_GO_PROMPT: {
        en: 'Before you go...',
        es: 'Antes de que te vayas...',
    },
    INTERVIEW_RECRUITMENT_BEFORE_YOU_GO_SUBPROMPT: {
        en: "Can we interview you to learn how we can improve? We'll give you a $25 Amazon gift card for about 15 minutes of your time.",
        es: '¿Podemos entrevistarlo para saber cómo podemos mejorar? Le daremos una tarjeta de regalo de Amazon de $25 por aproximadamente 15 minutos de su tiempo.',
    },
    INTERVIEW_RECRUITMENT_SCHEDULE_INTERVIEW: {
        en: 'Schedule Interview',
        es: 'Programar entrevista',
    },
    NO_THANKS: {
        en: 'No, thanks',
        es: 'No, gracias',
    },
    INTERVIEW_RECRUITMENT_THANK_YOU_PROMPT: {
        en: 'Thank you!',
        es: '¡Gracias!',
    },
    INTERVIEW_RECRUITMENT_THANK_YOU_SUBPROMPT: {
        en: "You can now exit and return to ".concat(PLACEHOLDER),
        es: "Ahora puede salir y regresar a ".concat(PLACEHOLDER),
    },
    INTERVIEW_RECRUITMENT_EXIT: {
        en: 'Exit',
        es: 'Salir',
    },
    GUIDED_SWITCH_INTRO: {
        en: 'To request a change to your direct deposit from the Social Security Administration you will need the following information:',
        es: 'Para solicitar un cambio a su depósito directo de la Administración de Seguridad Social, necesitará la siguiente información:',
    },
    LEGAL_FIRST_LAST_NAME: {
        en: 'Legal first and last name',
        es: 'Nombre y apellido legales',
    },
    SOCIAL_SECURITY_NUMBER: {
        en: 'Social Security number',
        es: 'Número de seguro social',
    },
    SOCIAL_SECURITY_NUMBER_LAST_4: {
        en: 'Social Security number (last 4 digits)',
        es: 'Número de seguro social (últimos 4 dígitos)',
    },
    OTHER: {
        en: 'Other',
        es: 'Otra',
    },
    SECURELY_LOGIN: {
        en: 'Securely log in to the payroll provider for your primary source of\u00A0income',
        es: 'Iniciar sesión de forma segura a su proveedor de nómina para tu primario fuente de\u00A0ingreso',
    },
    SELECT_HOW_MUCH: {
        en: "Select how much money you want deposited into your ".concat(PLACEHOLDER, " account per\u00A0paycheck"),
        es: "Seleccione cu\u00E1nto dinero desea depositar en su cuenta de ".concat(PLACEHOLDER, " por\u00A0cada cheque de n\u00F3mina"),
    },
    I_E_SHARING: {
        en: "Behind the scenes, we discreetly share your income and employment information with\u00A0".concat(PLACEHOLDER),
        es: "Detr\u00E1s de escena, discretamente compartimos su informaci\u00F3n de ingresos y empleo con\u00A0".concat(PLACEHOLDER),
    },
    WE_TAKE_CARE: {
        en: 'We take care of the\u00A0rest',
        es: 'Nosotros nos encargamos de el\u00A0resto',
    },
    PRIVATE_LOGIN_INFO: {
        en: 'Your login information stays\u00A0private',
        es: 'Tu información de acceso se mantiene\u00A0privada',
    },
    SELECT_YOUR_PROVIDER: {
        en: 'Find your employer’s payroll provider from our list of\u00A0thousands',
        es: 'Encuentra el proveedor de nómina de tu empleador entre nuestra lista de\u00A0miles',
    },
    POPULAR: {
        en: 'Popular',
        es: 'Popular',
    },
    PAYROLL_TITLE: {
        en: 'Payroll',
        es: 'Nómina',
    },
    GIG: {
        en: 'Gig',
        es: 'Gig',
    },
    SEARCH_PROMPT: {
        en: "Search for your employer or payroll\u00A0service\u00A0provider",
        es: "Busque su empleador o proveedor de servicios\u00A0de\u00A0n\u00F3mina",
    },
    SEARCH_TIP: {
        en: 'Search terms like "mcdonalds" or "paycor"',
        es: 'Términos de búsqueda como "mcdonalds" o "paycor"',
    },
    CANT_FIND_RESULT: {
        en: "Can't find what you're looking for?",
        es: "\u00BFNo encuentras lo que buscas?",
    },
    CANT_FIND_TIP: {
        en: "We're continually adding new employers and payroll providers so check back later.",
        es: "Continuamente agregamos nuevos empleadores y proveedores de n\u00F3mina, as\u00ED que vuelva a consultar m\u00E1s tarde.",
    },
    CANT_FIND_PAYROLL_PLATFORM_TIP: {
        en: "We're continuously adding new employers and payroll providers, so please check back later!",
        es: "Continuamente agregamos nuevos empleadores y proveedores de n\u00F3mina, as\u00ED que vuelva a consultar m\u00E1s tarde.",
    },
    DIRECT_DEPOSIT_FORM: {
        en: 'Direct deposit form',
        es: 'Formulario de depósito directo',
    },
    DD_FORM_REVIEW_AND_GENERATE: {
        en: 'Review the information below and create your form to share',
        es: 'Revise la información a continuación y cree su formulario para compartir',
    },
    NAME: {
        en: 'Name',
        es: 'Nombre',
    },
    DD_FORM_PROMPT: {
        en: 'Do you want to create a form to share with your employer instead?',
        es: '¿Quiere crear un formulario para compartirlo con su empleador?',
    },
    EDIT_THIS: {
        en: 'Edit this',
        es: 'Edita esto',
    },
    CHANGE_SIGNATURE_STYLE: {
        en: 'Change signature style',
        es: 'Cambiar estilo de firma',
    },
    GENERATE_FORM: {
        en: 'Create form',
        es: 'Crear formulario',
    },
    EXIT_AND_RETURN_TO_BANKAPP: {
        es: "Salir y volver a ".concat(PLACEHOLDER),
        en: "Exit & return to ".concat(PLACEHOLDER),
    },
    USE_A_FORM_INSTEAD: {
        en: 'Use a form instead',
        es: 'Usa un formulario en su lugar',
    },
    DOWNLOAD: {
        en: 'Download',
        es: 'Descargar',
    },
    VIEW_COMPLETED_FORM: {
        en: 'View Completed Form',
        es: 'Ver Formulario Completado',
    },
    SHARE: {
        en: 'Share',
        es: 'Cuota',
    },
    DD_FORM_SHARE: {
        en: "Share this form with your employer's HR/payroll department",
        es: 'Comparta este formulario con el departamento de recursos humanos / nómina de su empleador',
    },
    EMPLOYER_NAME: {
        en: 'Employer name',
        es: 'Nombre del empleador',
    },
    FULL_NAME: {
        en: 'Full name',
        es: 'Nombre completo',
    },
    FIRST_NAME: {
        en: 'First(given) name',
        es: 'Nombre(dado)',
    },
    LAST_NAME: {
        en: 'Last name(surname)',
        es: 'Apellido(s)',
    },
    WILL_THIS_AFFECT_MY_CREDIT_SCORE: {
        en: 'Will this affect my credit score?',
        es: '¿Esto afectará mi calidad crediticia?',
    },
    NO_WE_ONLY_USE_THIS_INFORMATION: {
        en: 'No. We only use this information to find matching records using bank-level encryption, and then delete it afterwards.',
        es: 'No. Solo usamos esta información para encontrar registros coincidentes usando cifrado de nivel de banco, y luego la eliminamos.',
    },
    PLEASE_REVIEW_AND_CONFIRM_THESE_DETAILS: {
        en: 'Please review and confirm these details.',
        es: 'Por favor revise y confirme estos detalles.',
    },
    BIRTHDATE: {
        en: 'Birthdate',
        es: 'Fecha de nacimiento',
    },
    SIGNATURE_STYLE_PROMPT: {
        en: 'Which signature style do you want to use?',
        es: '¿Qué estilo de firma quieres usar?',
    },
    DD_FORM_GENERATION_ERROR: {
        en: 'Creating your PDF failed. An alert has been sent to our engineering team to investigate the problem.',
        es: 'Error al crear tu PDF. Se ha enviado una alerta a nuestro equipo de ingeniería para investigar el problema.',
    },
    INCOME_SOURCES: {
        en: 'How many sources of income do you\u00a0have?',
        es: '¿Cuántas fuentes de ingresos\u00a0tiene?',
    },
    INCOME_SOURCES_DESCRIPTION: {
        en: 'To help us better serve you, select an option\u00a0from\u00a0below.',
        es: 'Para ayudarnos a brindarle un mejor servicio, seleccione una opción de\u00a0las\u00a0siguientes.',
    },
    INCOME_PRIMARY: {
        en: 'What is your primary source of\u00a0income?',
        es: '¿Cuál es su principal fuente de\u00a0ingresos?',
    },
    INCOME_TIMEFRAME: {
        en: 'How long have you been working at your primary source of\u00a0income?',
        es: '¿Cuánto tiempo lleva trabajando en su principal fuente de\u00a0ingresos?',
    },
    FULL_TIME_JOB: {
        en: 'Full-time job',
        es: 'Trabajo de tiempo completo',
    },
    PART_TIME_JOB: {
        en: 'Part-time job',
        es: 'Trabajo de medio tiempo',
    },
    GIG_WORK: {
        en: 'Gig work (Uber, Lyft, etc.)',
        es: 'Trabajo de gig (Uber, Lyft, etc.)',
    },
    CONTRACT_WORK: {
        en: 'Contract work (non-gig)',
        es: 'Trabajo por contrato',
    },
    GOVERNMENT_BENEFITS: {
        en: 'Government benefits',
        es: 'Beneficios del gobierno',
    },
    PENSION: {
        en: 'Pension',
        es: 'Pensión',
    },
    INVESTMENTS: {
        en: 'Investments',
        es: 'Inversiones',
    },
    UNDER_2_WEEKS: {
        en: '< 2 weeks',
        es: '< 2 semanas',
    },
    BETWEEN_2_4_WEEKS: {
        en: '2 - 4 weeks',
        es: '2 - 4 semanas',
    },
    BETWEEN_1_3_MONTHS: {
        en: '1 - 3 months',
        es: '1 - 3 meses',
    },
    BETWEEN_3_6_MONTHS: {
        en: '3 - 6 months',
        es: '3 - 6 meses',
    },
    OVER_6_MONTHS: {
        en: '6+ months',
        es: '6+ meses',
    },
    CARD_SWITCH_TITLE: {
        en: "Use your ".concat(PLACEHOLDER, " card for ").concat(PLACEHOLDER, " payouts?"),
        es: "\u00BFUsar su tarjeta de ".concat(PLACEHOLDER, " para pagos de ").concat(PLACEHOLDER, "?"),
    },
    CARD_SWITCH_SUBTITLE: {
        en: "You can also set this up later in your ".concat(PLACEHOLDER, " account."),
        es: "Tambi\u00E9n puede configurar esto m\u00E1s tarde en su cuenta de ".concat(PLACEHOLDER, "."),
    },
    USE_CARD: {
        en: "Use ".concat(PLACEHOLDER, " card"),
        es: "Usar tarjeta ".concat(PLACEHOLDER),
    },
    YOUR_DIRECT_DEPOSIT_AND_PAYOUT_CARD: {
        en: 'Your direct deposit and payout card settings have been updated',
        es: 'Se han actualizado las configuraciones de depósito directo y su tarjeta de pago',
    },
    DIRECT_DEPOSIT_UPDATED: {
        en: 'Direct deposit settings updated',
        es: 'Configuración de depósito directo actualizada',
    },
    DIRECT_DEPOSIT_UPDATED_AND_WILL: {
        en: 'Your direct deposit settings have been updated and will be effective in 1-2 payroll cycles, depending on your employer.',
        es: 'Su configuración de depósito directo se actualizó y los cambios serán efectuados en 1-2 ciclos de nómina dependiendo de tu empleador.',
    },
    PAYOUT_CARD_UPDATED_BUT: {
        en: 'Payout card settings updated, but...',
        es: 'Se actualizó la configuración de la tarjeta de pago, pero...',
    },
    CARD_ADDED_BUT: {
        en: 'Your card has been added, however we were unable to change your direct deposit settings.',
        es: 'Su tarjeta ha sido agregada, sin embargo, no pudimos cambiar su configuración de depósito directo.',
    },
    COULDNT_UPDATE_CARD: {
        en: "Unfortunately we couldn't update your account with your ".concat(PLACEHOLDER, " card."),
        es: "Lamentablemente, no pudimos actualizar su cuenta con su tarjeta ".concat(PLACEHOLDER, "."),
    },
    NO_RESULTS_NO_PROBLEM: {
        en: 'No results? No problem.',
        es: '¿No hay resultados? Ningún problema.',
    },
    YOU_CAN_GENERATE_A_FORM: {
        en: "You can create a request form to give to your employer's HR department.",
        es: 'Puede crear un formulario de solicitud para entregar al departamento de recursos humanos de su empleador.',
    },
    CREATE_A_FORM: {
        en: 'Create a form',
        es: 'Crear un formulario',
    },
    AUTOMATED_DDS_DISABLED_FOR_ACCOUNT: {
        en: 'Automated direct deposit switching is disabled for your account',
        es: 'El cambio de depósito directo automatizado está deshabilitado para su cuenta',
    },
    UPLOAD_DOCUMENTS: {
        en: 'Upload documents',
        es: 'Cargar documentos',
    },
    DOCUMENT_UPLOADS_PRIMER: {
        en: "Share paystubs with ".concat(PLACEHOLDER, " to help verify your income and employment."),
        es: "Comparte los talones de pago con ".concat(PLACEHOLDER, " para ayudar a verificar tus ingresos y empleo."),
    },
    DOCUMENTS_SUBMITTED: {
        en: 'Documents submitted',
        es: 'Documentos presentado',
    },
    DOCUMENTS_SUBMITTED_FOLLOW_UP: {
        en: "".concat(PLACEHOLDER, " will let you know when your documents have been reviewed and verified."),
        es: "".concat(PLACEHOLDER, " te informar\u00E1 cuando tus documentos hayan sido revisados y verificados."),
    },
    DD_FORM_PRIMER: {
        en: "Create a traditional form that can be sent to your employer's HR department to update your direct deposit settings.",
        es: 'Cree un formulario tradicional que pueda enviarse al departamento de recursos humanos de su empleador para actualizar su configuración de depósito directo.',
    },
    GET_STARTED: {
        en: 'Get started',
        es: 'Empezar',
    },
    CREDIT_SCORE_QUALITY: {
        en: 'How would you rate your credit quality?',
        es: '¿Cómo calificaría su calidad crediticia?',
    },
    INFORMATION_USE_NOTICE: {
        en: 'Your answer is used solely for informational purposes and will not affect your app experience in any way.',
        es: 'Su respuesta se utiliza únicamente con fines informativos y no afectará su experiencia con la aplicación de ninguna manera.',
    },
    DONT_KNOW: {
        en: 'I don’t know',
        es: 'No sé',
    },
    RATHER_NOT_SAY: {
        en: 'I’d rather not say',
        es: 'Prefiero no decir',
    },
    YEARLY_PRETAX_INCOME: {
        en: 'What is your yearly pre-tax income?',
        es: '¿Cuál es su ingreso anual antes de impuestos?',
    },
    // TODO: for the localization of currency values, we will want to introduce a currency util
    // since the format of monetary amounts will defer by language/country.
    UNDER_DOLLAR_AMOUNT: {
        en: "Under $".concat(PLACEHOLDER),
        es: "Menos de $".concat(PLACEHOLDER),
    },
    DOLLAR_AMOUNT_TO_AMOUNT: {
        en: "$".concat(PLACEHOLDER, " to $").concat(PLACEHOLDER),
        es: "$".concat(PLACEHOLDER, " a $").concat(PLACEHOLDER),
    },
    DOLLAR_AMOUNT_PLUS: {
        en: "$".concat(PLACEHOLDER, "+"),
        es: "$".concat(PLACEHOLDER, "+"),
    },
    REVIEW_DATA: {
        en: 'Review Data',
        es: 'Revisar Datos',
    },
    DELETE: {
        en: 'Delete',
        es: 'Eliminar',
    },
    CANCEL: {
        en: 'Cancel',
        es: 'Cancelar',
    },
    SUBMIT: {
        en: 'Submit',
        es: 'Enviar',
    },
    SUBMITTING: {
        en: 'Submitting...',
        es: 'Enviando...',
    },
    DELETE_DOCUMENT: {
        en: 'Delete document?',
        es: '¿Eliminar documento?',
    },
    ADD_ANOTHER_DOCUMENT: {
        en: 'Add another document',
        es: 'Agregar otro documento',
    },
    DELETE_DOCUMENT_EXPLAINER: {
        en: 'Deleting this document removes it from this list. You will retain your copy.',
        es: 'Eliminar este documento lo elimina de esta lista. Mantendrás tu copia.',
    },
    DOCUMENT_UPLOAD_FAILED: {
        en: 'Document upload failed',
        es: 'La carga del documento ha fallado',
    },
    DOCUMENT_UPLOAD_FILE_SIZE_EXCEEDED: {
        en: 'Maximum file size exceeded',
        es: 'Tamaño máximo de archivo excedido',
    },
    DOCUMENT_UPLOAD_TRY_FILE_BELOW_SIZE_MB: {
        en: "Please upload a file that is ".concat(PLACEHOLDER, " MB or smaller."),
        es: "Cargue un archivo de ".concat(PLACEHOLDER, " MB o menos."),
    },
    DOCUMENT_UPLOAD_UNSUPPORTED_FILE_TYPE: {
        en: 'Unsupported file type',
        es: 'Tipo de archivo no soportado',
    },
    DOCUMENT_UPLOAD_TRY_FILE_IMAGE_PDF: {
        en: 'Please upload an image or PDF.',
        es: 'Sube una imagen o PDF.',
    },
    UPLOAD_DOCUMENT_INSTEAD: {
        en: 'Upload documents instead',
        es: 'Subir documentos en su lugar',
    },
    DOCUMENT_UPLOAD_FAILED_FOLLOW_UP: {
        en: 'How would you like to proceed?',
        es: '¿Cómo te gustaría proceder?',
    },
    TRY_UPLOADING_AGAIN: {
        en: 'Try uploading again',
        es: 'Intenta subir de nuevo',
    },
    TRY_AGAIN: {
        en: 'Try again',
        es: 'Intentar otra vez',
    },
    SELECT_DIFFERENT_DOCUMENT: {
        en: 'Select different document',
        es: 'Seleccionar un documento diferente',
    },
    REMOVE_FROM_LIST: {
        en: 'Remove from list',
        es: 'Eliminar de la lista',
    },
    NO_PDF_PLUGIN: {
        en: "It appears you don't have a PDF plugin for this browser. Click the button below to download the PDF file.",
        es: 'Parece que no tiene un complemento de PDF para este navegador. Haga clic en el botón de abajo para descargar el archivo PDF.',
    },
    UPLOADED: {
        en: 'Uploaded',
        es: 'Subido',
    },
    UPLOADING: {
        en: 'Uploading...',
        es: 'Subiendo...',
    },
    FAILED: {
        en: 'Failed',
        es: 'Fallida',
    },
    PAYSTUB_DOCUMENTS: {
        en: 'Paystub documents',
        // TODO: is this an accurate translation?
        es: 'Recibos de pago',
    },
    RETURN_TO_SEARCH: {
        en: 'Return to Search',
        es: 'Regresar a la búsqueda',
    },
    RETURN_TO_AMEX: {
        en: 'Return to Amex',
        es: 'Regresar a Amex',
    },
    RETURN_TO_MAIN_MENU: {
        en: 'Return to Main Menu',
        es: 'Volver al Menú Principal',
    },
    FAILED_TO_SUBMIT_DOCUMENTS: {
        en: 'Failed to submit documents.',
        es: 'No pudo presentar los documentos.',
    },
    ENTER_ACCOUNT_NUMBER_Y12: {
        en: 'Enter your 13-digit Y12 Credit Union account number where you want your paycheck to be deposited.',
        es: 'Ingrese su número de cuenta de 13 dígitos de Y12 Credit Union donde desea que se deposite su cheque de pago.',
    },
    ENTER_ACCOUNT_NUMBER: {
        en: 'Enter the account number where you want your paycheck to be deposited',
        es: 'Ingrese el número de cuenta donde desea que se deposite su cheque de pago',
    },
    ENTER_ROUTING_AND_ACCOUNT_NUMBER: {
        en: 'Enter the routing and account number where you want your paycheck to be deposited',
        es: 'Ingrese el número de ruta y cuenta donde desea que se deposite su cheque de pago',
    },
    FORM_READY_TITLE: {
        en: 'Form ready',
        es: 'Formulario listo',
    },
    FORM_READY_DESCRIPTION: {
        en: 'Your form is ready to be shared with your employer’s HR or payroll department',
        es: 'Su formulario está listo para ser compartido con el departamento de recursos humanos o de nómina de su empleador',
    },
    LOADING: {
        en: 'Loading...',
        es: 'Cargando...',
    },
    SETTING_UP_SECURE_CONNECTION: {
        en: 'Setting up a secure connection',
        es: 'Configuración de una conexión segura',
    },
    CONNECTING_YOUR_ACCOUNT: {
        en: 'Connecting to your account',
        es: 'Conexión a su cuenta',
    },
    ALMOST_THERE_MAY_TAKE_FEW_MOMENTS: {
        en: 'Almost there! This may take a few moments',
        es: '¡Casi llegamos! Esto puede tomar unos momentos',
    },
    WORKING_ON_GETTING_YOU_CONNECTED: {
        en: 'Working on getting you connected',
        es: 'Trabajando para conectarte',
    },
    MANUAL_INSTRUCTIONS_FOR_PLATFORM: {
        en: "Manual instructions for ".concat(PLACEHOLDER),
        es: "Instrucciones manuales para ".concat(PLACEHOLDER),
    },
    AUTOMATED_DDS_DISABLED: {
        en: 'Automated direct deposit switching disabled',
        es: 'Cambio automático de depósito directo deshabilitado',
    },
    PLATFORM_HAS_TEMPORARILY_DISABLED: {
        en: "Sorry, ".concat(PLACEHOLDER, " has temporarily disabled automated direct deposit switching. You can still complete your switch manually."),
        es: "Lo sentimos, ".concat(PLACEHOLDER, " ha inhabilitado temporalmente el cambio autom\u00E1tico de dep\u00F3sito directo. A\u00FAn puedes completar tu cambio manualmente."),
    },
    GENERIC_TEMPORARILY_DISABLED: {
        en: 'Sorry, automated direct deposit switching is currently disabled. You can still complete your switch manually.',
        es: 'Lo sentimos, el cambio automático de depósito directo está actualmente deshabilitado. Aún puedes completar tu cambio manualmente.',
    },
    VIEW_MANUAL_INSTRUCTIONS: {
        en: 'View manual instructions',
        es: 'Ver instrucciones manuales',
    },
    USE_ACCOUNT_DETAILS: {
        en: 'Use these account details:',
        es: 'Datos bancarios:',
    },
    MS_ELIGIBILITY_LOOKUP_TEXT: {
        en: 'Looking up your payroll account…',
        es: 'Buscando su cuenta de nómina…',
    },
    MS_ELIGIBILITY_LOOKUP_SUBTEXT: {
        en: 'This should take less than 20 seconds.',
        es: 'Esto debería tomar menos de 20 segundos.',
    },
    LOOK_UP_ACCOUNT: {
        en: 'Look up account',
        es: 'Buscar cuenta',
    },
    MS_ELIGIBILITY_SKIP: {
        en: 'Skip',
        es: 'Omitir',
    },
    MS_ELIGIBILITY_HELP_SECTION_1_TITLE: {
        en: 'What is a payroll provider?',
        es: '¿Qué es un proveedor de nómina?',
    },
    MS_ELIGIBILITY_HELP_SECTION_1_CONTENT: {
        en: 'A payroll service provider (PSP) is a third-party that can help an employer administer payroll and employment tax obligations. Nearly all employers use a third-party service to pay employees.',
        es: 'Un proveedor de servicios de nómina (PSP) es un tercero que puede ayudar a un empleador a administrar las obligaciones fiscales y de nómina. Casi todos los empleadores usan un servicio externo para pagar a los empleados.',
    },
    MS_ELIGIBILITY_HELP_SECTION_2_TITLE: {
        en: 'How do I know who my payroll provider is?',
        es: '¿Cómo sé quién es mi proveedor de nómina?',
    },
    MS_ELIGIBILITY_HELP_SECTION_2_CONTENT: {
        en: 'Most of the time your payroll provider’s name will be included on your paycheck or paystub. Your payroll provider may also be your employer’s HR system or portal which you use to track your working hours, paid time off, benefits, or other HR-related services.',
        es: 'La mayoría de las veces el nombre de su proveedor de nómina estará incluido en su cheque de pago o talón de pago. Su proveedor de nómina también puede ser el sistema o portal de RR.HH. de su empleador, que usted utiliza para llevar un registro de sus horas de trabajo, tiempo libre pagado, beneficios u otros servicios relacionados con RR.HH.',
    },
    MS_ELIGIBILITY_HELP_SUBMIT: {
        en: 'Got it',
        es: 'Entendido',
    },
    MS_ELIGIBILITY_NO_RESULTS_TITLE: {
        en: 'Employer lookup unsuccessful',
        es: 'Búsqueda del empleador no exitosa',
    },
    MS_ELIGIBILITY_NO_RESULTS_DESCRIPTION: {
        en: "Don't worry, you can search our database of employers and payroll providers on the next step.",
        es: 'No se preocupe, puede buscar en nuestra base de datos de empleadores y proveedores de nómina en el siguiente paso.',
    },
    MS_ELIGIBILITY_NO_RESULTS_CONTINUE: {
        en: 'Continue to search',
        es: 'Continuar a búsqueda',
    },
    MS_ELIGIBILITY_SINGLE_ACCOUNT_TITLE: {
        en: "Continue with ".concat(PLACEHOLDER, "?"),
        es: "\u00BFContinuar con ".concat(PLACEHOLDER, "?"),
    },
    MS_ELIGIBILITY_SINGLE_ACCOUNT_TITLE_ADP: {
        en: "We found your payroll account with ADP",
        es: "Encontramos su cuenta de n\u00F3mina con ADP",
    },
    MS_ELIGIBILITY_SINGLE_ACCOUNT_SUBTITLE_EMPLOYER: {
        en: "We found an account with the payroll provider ".concat(PLACEHOLDER, " that matches your information. Continue to update your direct deposit settings for <b>").concat(PLACEHOLDER, "</b>."),
        es: "Encontramos una cuenta con el proveedor de n\u00F3minas ".concat(PLACEHOLDER, " que coincide con su informaci\u00F3n. Contin\u00FAe actualizando su configuraci\u00F3n de dep\u00F3sito directo para <b>").concat(PLACEHOLDER, "</b>."),
    },
    MS_ELIGIBILITY_SINGLE_ACCOUNT_SUBTITLE_NO_EMPLOYER: {
        en: "We found an account with the payroll provider ".concat(PLACEHOLDER, " that matches your information. Continue to update your direct deposit settings."),
        es: "Encontramos una cuenta con el proveedor de n\u00F3minas ".concat(PLACEHOLDER, " que coincide con su informaci\u00F3n. Contin\u00FAe actualizando su configuraci\u00F3n de dep\u00F3sito directo"),
    },
    MS_ELIGIBILITY_SINGLE_ACCOUNT_CONTINUE: {
        en: "Continue with ".concat(PLACEHOLDER),
        es: "Continuar con ".concat(PLACEHOLDER),
    },
    MS_ELIGIBILITY_SINGLE_ACCOUNT_CONTINUE_WITH_EMPLOYER: {
        en: "Yes, continue with ".concat(PLACEHOLDER),
        es: "S\u00ED, continuar con ".concat(PLACEHOLDER),
    },
    MS_ELIGIBILITY_SINGLE_ACCOUNT_SKIP: {
        en: "Search for different account",
        es: "Buscar una cuenta diferente",
    },
    MS_ELIGIBILITY_MULTIPLE_ACCOUNTS_TITLE: {
        en: 'We found multiple matches',
        es: 'Encontramos varias coincidencias',
    },
    MS_ELIGIBILITY_MULTIPLE_ACCOUNTS_SUBITLE: {
        en: 'You have accounts at multiple payroll providers. Which is your current, primary payroll provider?',
        es: 'Tiene cuentas en varios proveedores de nómina. ¿Cuál es su proveedor de nómina principal actual?',
    },
    MS_ELIGIBILITY_MULTIPLE_ACCOUNTS_SKIP: {
        en: 'None of these',
        es: 'Ninguno de estos',
    },
    REDIRECTING_YOU_TO_ADP: {
        en: 'Redirecting you to ADP',
        es: 'Redirigiéndote a ADP',
    },
    ADP_REDIRECT_INTERSTITIAL: {
        en: "Switch your direct deposit with ADP by using their system directly. After configuring and confirming you will be returned to ".concat(PLACEHOLDER, "."),
        es: "Cambie su dep\u00F3sito directo con ADP usando su sistema directamente. Despu\u00E9s de configurarlo y confirmarlo, volver\u00E1 a ".concat(PLACEHOLDER, "."),
    },
    SEARCH_FOR_A_DIFFERENT_ACCOUNT: {
        en: 'Search for a different account?',
        es: '¿Buscar una cuenta diferente?',
    },
    SEARCH_OUR_DATABASE: {
        en: 'Search our database of thousands of payroll providers to find yours.',
        es: 'Busque en nuestra base de datos de miles de proveedores de nómina para encontrar el suyo.',
    },
    MULTI_SUPPLIER_ELIGIBILITY_NO_MATCH: {
        en: "We couldn't identify your payroll service provider automatically. Check your latest paystub to see what payroll service provider your employer uses, then search our database of thousands to find yours.",
        es: 'No pudimos identificar automáticamente a su proveedor de servicios de nómina. Consulte su recibo de sueldo más reciente para ver qué proveedor de servicios de nómina utiliza su empleador, luego busque en nuestra base de datos de miles para encontrar el suyo.',
    },
    LETS_DO_IT: {
        en: "Let's do it",
        es: 'Vamos a hacerlo',
    },
    LETS_FIND_YOUR_PAYROLL_ACCOUNT: {
        en: "Let's find your payroll account",
        es: 'Vamos a encontrar su cuenta de nómina',
    },
    ENTER_YOUR_TELEPHONE_NUMBER: {
        en: 'Enter your telephone number',
        es: 'Ingrese su número de teléfono',
    },
    TELEPHONE_NUMBER: {
        en: 'Telephone number',
        es: 'Número de teléfono',
    },
    ENTER_YOUR_NAME: {
        en: 'Enter your name as your employer would have on file.',
        es: 'Ingrese su nombre como lo tiene su empleador en archivo.',
    },
    ENTER_YOUR_BIRTHDATE: {
        en: 'Enter your birthdate',
        es: 'Ingrese su fecha de nacimiento',
    },
    ENTER_YOUR_SOCIAL_SECURITY_NUMBER: {
        en: 'Enter your Social Security number',
        es: 'Ingrese su número de Seguridad Social',
    },
    ENTER_YOUR_SOCIAL_SECURITY_NUMBER_4_DIGITS: {
        en: 'Enter your Social Security number (4 digits)',
        es: 'Ingrese su número de Seguridad Social (4 dígitos)',
    },
    PAYROLL_ACCOUNT_FOUND: {
        en: 'Payroll account found',
        es: 'Cuenta de nómina encontrada',
    },
    WE_FOUND_AN_ACCOUNT: {
        en: "Good news! We found a payroll account in your name with ".concat(PLACEHOLDER, "."),
        es: "\u00A1Buenas noticias! Encontramos una cuenta de n\u00F3mina a su nombre con ".concat(PLACEHOLDER, "."),
    },
    CONTINUE_SEARCHING: {
        en: 'Continue searching',
        es: 'Continuar buscando',
    },
    SEARCH_MANUALLY: {
        en: 'Search Manually',
        es: 'Buscar manualmente',
    },
    SELECT_ACCOUNT_TITLE: {
        en: 'Select the account to receive direct deposits',
        es: 'Seleccione la cuenta para recibir depósitos directos',
    },
    SET_UP_ANOTHER_ALLOCATION: {
        en: 'Set up another allocation',
        es: 'Configurar otra asignación',
    },
    SELECT_ACCOUNT_SUBTITLE: {
        en: 'For multiple allocations, select one at a time.',
        es: 'Para cuentas múltiples, seleccione una a la vez.',
    },
    SAFELINK_TITLE: {
        en: 'Continue with SafeLink',
        es: 'Continuar con SafeLink',
    },
    SAFELINK_TITLE_WEB: {
        en: 'Scan the QR code to sign in',
        es: 'Escanea el código QR para iniciar sesión',
    },
    SAFELINK_SUBTITLE_IOS: {
        en: 'This provider requires you to use an App Clip, a way to securely sign in without downloading a full app.',
        es: 'Este proveedor requiere que utilices un App Clip, una forma de iniciar sesión de forma segura sin descargar una aplicación completa.',
    },
    SAFELINK_SUBTITLE_ANDROID: {
        en: 'This provider requires you to use an Instant App, a way to securely sign in without downloading a full app.',
        es: 'Este proveedor requiere que utilices un Instant App, una forma de iniciar sesión de forma segura sin descargar una aplicación completa.',
    },
    SAFELINK_SUBTITLE_WEB: {
        en: 'This provider requires you to use SafeLink on your mobile phone to securely sign in.',
        es: 'Este proveedor requiere que utilice SafeLink en su teléfono móvil para iniciar sesión de forma segura.',
    },
    SWITCH_ALL_OR_PORTION: {
        en: 'Switch all or just a portion of your direct deposit in minutes.',
        es: 'Cambia toda o solo una parte de tu depósito directo en minutos.',
    },
    YOU_WILL_NEED: {
        en: 'You will need to know your payroll provider and login credentials.',
        es: 'Necesitarás saber quién es tu proveedor de nómina y tus credenciales de inicio de sesión.',
    },
    PAYROLL_PROVIDED_BY: {
        en: "Payroll provided by ".concat(PLACEHOLDER),
        es: "N\u00F3mina proporcionada por ".concat(PLACEHOLDER),
    },
    DO_YOU_WORK_FOR: {
        en: "Do you work for ".concat(PLACEHOLDER, "?"),
        es: "\u00BFTrabajas para ".concat(PLACEHOLDER, "?"),
    },
    WE_FOUND_AN_ACCOUNT_WITH_EMPLOYER: {
        en: "We found an account with the payroll provider ".concat(PLACEHOLDER, " for ").concat(PLACEHOLDER, " that matches your information. Is that you?"),
        es: "Encontramos una cuenta con el proveedor de n\u00F3mina ".concat(PLACEHOLDER, " para ").concat(PLACEHOLDER, " que coincide con su informaci\u00F3n. \u00BFEres t\u00FA?"),
    },
    CONFIRM_ACCOUNT_DETAILS: {
        en: 'Confirm account details',
        es: 'Confirmar detalles de la cuenta',
    },
    EDGE_NATIVE_LOADING: {
        en: 'Hold tight, loading...',
        es: 'Espera, cargando...',
    },
    CHECK_ALL_THAT_APPLY: {
        en: 'Check all that apply',
        es: 'Marque todo lo que corresponda',
    },
    NO_INCOME: {
        en: 'I do not have any income',
        es: 'No tengo ningun ingreso',
    },
    WIZARD_INCOME_SOURCES_TITLE: {
        en: 'What are your income sources?',
        es: '¿Cuáles son sus fuentes de ingresos?',
    },
    WIZARD_INCOME_SOURCES_CHECKBOX_W2: {
        en: 'Full or part time job',
        es: 'Trabajo a tiempo completo o parcial',
    },
    WIZARD_INCOME_SOURCES_CHECKBOX_W2_DESC: {
        en: 'W2 employment',
        es: 'W2 ocupación',
    },
    WIZARD_INCOME_SOURCES_CHECKBOX_1099: {
        en: 'Gig, contract, or freelance',
        es: 'Concierto, contrato o autónomo',
    },
    WIZARD_INCOME_SOURCES_CHECKBOX_1099_DESC: {
        en: '1099 employment',
        es: '1099 ocupación',
    },
    WIZARD_INCOME_SOURCES_CHECKBOX_BENEFITS: {
        en: 'Government or employer benefits',
        es: 'Beneficios del gobierno o del empleador',
    },
    WIZARD_INCOME_SOURCES_CHECKBOX_BENEFITS_DESC: {
        en: 'SSI, SSA, pensions, or unemployment',
        es: 'SSI, SSA, pensiones o desempleo',
    },
    WIZARD_INCOME_SOURCES_CHECKBOX_SELF_EMPLOYED: {
        en: 'My own business',
        es: 'Mi propio negocio',
    },
    WIZARD_INCOME_SOURCES_CHECKBOX_SELF_EMPLOYED_DESC: {
        en: 'Self-employed or business owner',
        es: 'Trabajador por cuenta propia o propietario de un negocio',
    },
    WIZARD_PAYMENT_METHODS_TITLE: {
        en: 'How do you get paid?',
        es: '¿Como te pagan?',
    },
    WIZARD_PAYMENT_METHODS_CHECKBOX_CASH: {
        en: 'Cash or Venmo, Zelle, Cash App, etc. transfer',
        es: 'Transferencia en efectivo o Venmo, Zelle, Cash App, etc.',
    },
    WIZARD_PAYMENT_METHODS_CHECKBOX_DIRECT_DEPOSIT: {
        en: 'Direct deposit to bank account',
        es: 'Depósito directo a cuenta bancaria',
    },
    WIZARD_PAYMENT_METHODS_CHECKBOX_DEBIT_CARD: {
        en: 'Instant withdrawal to debit card',
        es: 'Retiro instantáneo a tarjeta de débito',
    },
    WIZARD_PAYMENT_METHODS_CHECKBOX_CHECK: {
        en: 'Paper check',
        es: 'Cheque en papel',
    },
    WIZARD_PAYMENT_METHODS_CHECKBOX_PAY_CARD: {
        en: 'Pay card',
        es: 'Tarjeta de pago',
    },
    WIZARD_PAYMENT_METHODS_CHECKBOX_OTHER_PLACEHOLDER: {
        en: 'Payment type',
        es: 'Tipo de pago',
    },
    WIZARD_INCOME_SOURCE_BENEFITS_TITLE: {
        en: 'What benefits do you receive?',
        es: '¿Qué beneficios recibe?',
    },
    WIZARD_INCOME_SOURCE_BENEFITS_PENSION: {
        en: 'Pension',
        es: 'Pensión',
    },
    WIZARD_INCOME_SOURCE_BENEFITS_UNEMPLOYMENT: {
        en: 'Unemployment',
        es: 'Desempleo',
    },
    WIZARD_INCOME_SOURCE_BENEFITS_SSR: {
        en: 'Social Security Retirement',
        es: 'Jubilación del Seguro Social',
    },
    WIZARD_INCOME_SOURCE_BENEFITS_SUPPLEMENTAL: {
        en: 'Supplemental Security Income',
        es: 'Ingreso de seguridad suplementario',
    },
    WIZARD_INCOME_SOURCE_BENEFITS_MILITARY: {
        en: 'Veterans/military benefits',
        es: 'Veteranos / beneficios militares',
    },
    WIZARD_INCOME_SOURCE_BENEFITS_OTHER: {
        en: 'Food, housing, energy, or other government benefits',
        es: 'Alimentos, vivienda, energía u otros beneficios gubernamentales.',
    },
    WIZARD_INCOME_SOURCE_W2: {
        en: 'How many full or part time jobs do you currently have?',
        es: '¿Cuántos trabajos de tiempo completo o parcial tiene actualmente?',
    },
    WIZARD_INCOME_SOURCE_1099: {
        en: 'Is your gig, contract, or freelance income your primary income?',
        es: '¿Sus ingresos por trabajo, contrato o trabajo independiente son su ingreso principal?',
    },
    WIZARD_ERROR: {
        en: "Unfortunately, we won't be able to help you change or set up your direct deposit at this time.",
        es: 'Desafortunadamente, no podremos ayudarlo a cambiar o configurar su depósito directo en este momento.',
    },
    DEVICE_BASED_PRIMER_TITLE: {
        en: "Continue with ".concat(PLACEHOLDER),
        es: "Continuar con ".concat(PLACEHOLDER),
    },
    DEVICE_BASED_PRIMER_SUBTITLE: {
        en: "".concat(PLACEHOLDER, " requires you to log in directly to their site. After logging in you will be returned to complete the\u00A0process."),
        es: "".concat(PLACEHOLDER, " requiere que inicie sesi\u00F3n directamente en su sitio. Despu\u00E9s de iniciar sesi\u00F3n, volver\u00E1 a completar el\u00A0proceso."),
    },
    CITIZENS_INTRO_TITLE: {
        en: 'Set up direct deposit in 3 easy steps',
        es: 'Configure el depósito directo en 3 sencillos pasos',
    },
    CITIZENS_INTRO_STEP_1_TITLE: {
        en: 'Step 1: Find who pays you',
        es: 'Paso 1: Encuentra quién te paga',
    },
    CITIZENS_INTRO_STEP_2_TITLE: {
        en: 'Step 2: Log in to your payroll provider',
        es: 'Paso 2: inicie sesión en su proveedor de nómina',
    },
    CITIZENS_INTRO_STEP_3_TITLE: {
        en: 'Step 3: Set up your direct deposit',
        es: 'Paso 3: Configure su depósito directo',
    },
    CITIZENS_INTRO_STEP_1_TEXT: {
        en: 'Search from over 1 million employers and payroll providers',
        es: 'Busque entre más de 1 millón de empleadores y proveedores de nómina',
    },
    CITIZENS_INTRO_STEP_2_TEXT: {
        en: 'Use your payroll credentials to log in',
        es: 'Utilice sus credenciales de nómina para iniciar sesión',
    },
    CITIZENS_INTRO_STEP_3_TEXT: {
        en: 'Deposit your pay into 1 account or split it between multiple',
        es: 'Deposite su pago en 1 cuenta o divídalo entre varias',
    },
    LOGIN_USING_CREDENTIALS_BTN_TITLE: {
        en: 'Log in using credentials',
        es: 'Iniciar sesión con credenciales',
    },
    LOGIN_USING_PII: {
        en: 'Log in using personal information',
        es: 'Iniciar sesión con información personal',
    },
    BILL_NAVIGATOR_TITLE: {
        en: 'Welcome to Bill Navigator, powered by Pinwheel',
        es: 'Bienvenido a Bill Navigator, desarrollado con Pinwheel',
    },
    BILL_NAVIGATOR: {
        en: 'Bill Navigator',
        es: 'Bill Navigator',
    },
    MANAGE_BILLS: {
        en: 'Manage all your bills in one place',
        es: 'Gestiona todas tus facturas en un solo lugar',
    },
    FIND_AND_CANCEL_SUBSCRIPTIONS: {
        en: 'Find and cancel unwanted subscriptions',
        es: 'Encuentre y cancele suscripciones no deseadas',
    },
    ALERTS_AND_REMINDERS: {
        en: 'Get alerts and reminders',
        es: 'Reciba alertas y recordatorios',
    },
    BILL_SWITCH_SUCCESS: {
        en: 'Your payment settings have been updated.',
        es: '',
    },
    BILL_CANCELLATION_SUCCESS: {
        en: 'Your account has been cancelled.',
        es: '',
    },
    SWITCH_KIT: {
        en: 'Switch Kit',
        es: 'Switch Kit',
    },
    SWITCH_KIT_INTRO_TITLE: {
        en: "".concat(PLACEHOLDER, " uses Pinwheel to safely access your other accounts"),
        es: "".concat(PLACEHOLDER, " usa Pinwheel para acceder de forma segura a sus otras cuentas"),
    },
    SWITCH_KIT_INTRO_ROW_1: {
        en: 'Keep sensitive account information private and secure',
        es: 'Mantenga la información de la cuenta privada y segura',
    },
    SWITCH_KIT_INTRO_ROW_2: {
        en: "Complete in minutes without leaving ".concat(PLACEHOLDER),
        es: "Complete en minutos sin salir de ".concat(PLACEHOLDER),
    },
    SWITCH_KIT_SUCCESS_TITLE: {
        en: 'Switch your bills, too?',
        es: '¿Cambiar también sus facturas?',
    },
    SWITCH_KIT_SUCCESS_SUBTITLE: {
        en: "Direct deposit is now set up. Do you want to switch your bills to pay with ".concat(PLACEHOLDER, " now?"),
        es: "El dep\u00F3sito directo ahora est\u00E1 configurado. \u00BFQuiere cambiar sus facturas para pagar con ".concat(PLACEHOLDER, " ahora?"),
    },
    SWITCH_KIT_SUCCESS_BUTTON: {
        en: 'Continue and switch bills',
        es: 'Continuar y cambiar facturas',
    },
};
export var getLocalizedStringFn = function (language, workspace) {
    return function (stringId, values) {
        var _a;
        var str;
        if (workspace &&
            ((_a = WORKSPACE_SPECIFIC_LOCALIZED_STRINGS[workspace]) === null || _a === void 0 ? void 0 : _a[stringId])) {
            str = WORKSPACE_SPECIFIC_LOCALIZED_STRINGS[workspace][stringId][language];
        }
        else {
            str = LOCALIZED_STRINGS[stringId][language];
        }
        if (values) {
            for (var i = 0; i < values.length; i++) {
                if (str.indexOf(PLACEHOLDER) >= 0) {
                    str = str.replace(PLACEHOLDER, values[i]);
                    str = cleanPartnerBasedPlatformNames(str);
                }
            }
        }
        return str;
    };
};
